import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CONSENT_STORAGE_KEY = 'printtrio_cookie_consent_v2';

const deniedConsent = {
  ad_storage: 'denied',
  analytics_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  functionality_storage: 'granted',
  security_storage: 'granted',
};

const grantedConsent = {
  ad_storage: 'granted',
  analytics_storage: 'granted',
  ad_user_data: 'granted',
  ad_personalization: 'granted',
  functionality_storage: 'granted',
  security_storage: 'granted',
};

const updateConsent = (status) => {
  const consentPayload = status === 'granted' ? grantedConsent : deniedConsent;

  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, status);
  } catch (error) {}

  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('consent', 'update', consentPayload);
  }
};

const CookieConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      const savedConsent = localStorage.getItem(CONSENT_STORAGE_KEY);
      setIsVisible(!savedConsent);
    } catch (error) {
      setIsVisible(true);
    }
  }, []);

  const handleConsent = (status) => {
    updateConsent(status);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] border-t border-gray-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-screen-2xl flex-col gap-4 px-4 py-4 sm:px-6 lg:flex-row lg:items-center lg:justify-between xl:px-20">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold text-gray-900">Cookie preferences</p>
          <p className="mt-1 text-sm text-gray-600">
            We use cookies to measure traffic and improve marketing performance. You can accept or reject
            analytics and advertising cookies. Read more in our{' '}
            <Link to="/privac-policy" className="text-pink-600 underline underline-offset-2">
              Privacy Policy
            </Link>.
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => handleConsent('denied')}
            className="rounded-full border border-gray-300 px-5 py-2 text-sm font-semibold text-gray-700 transition hover:border-gray-400 hover:bg-gray-50"
          >
            Reject non-essential
          </button>
          <button
            type="button"
            onClick={() => handleConsent('granted')}
            className="rounded-full bg-pink-500 px-5 py-2 text-sm font-semibold text-white transition hover:bg-pink-600"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
